module.exports = __webpack_public_path__ + "static/media/answer.846e1dd4.png";